<section class="scroll-section" #scrollSection>
  <div class="sticky-container">
    <div class="content-wrapper">
      
      <div class="image-column">
        <img [src]="imgLink" alt="Woman on video call smiling">
      </div>

      <div class="steps-column">
        @for (step of steps; track step.id; let i = $index) {
          <div class="step">
            
            <div class="line-wrapper">
              <div class="line-bg">
                <div class="line-fill" [style.height.%]="getFillPercentage(i)"></div>
              </div>
            </div>

            <div class="text-content">
              <h3 [class.active-text]="getFillPercentage(i) > 0">{{ step.title }}</h3>
              <p [class.active-text]="getFillPercentage(i) > 0">{{ step.description }}</p>
            </div>
            
          </div>
        }
      </div>

    </div>
  </div>
</section>